import { commonTypoStyles } from "@iewcasia/Utilities/styleguide/FormFields/FormField";
import { mediaQueriesBP } from "@iewcasia/Utilities/variables";
import { DynamicDropdownPresentationProps } from "@insite/mobius/DynamicDropdown";
import { sizeVariantValues } from "@insite/mobius/FormField/formStyles";
import RecursivePartial from "@insite/mobius/utilities/RecursivePartial";
import { css } from "styled-components";

const lineHeightSize = ({ _sizeVariant }: any) => {
    const sizeVariant: string = _sizeVariant ?? "default";
    const currentSize = (sizeVariantValues as any)[sizeVariant].height ?? 40;
    return `${currentSize}px`;
};

export const dynamicDropdown: RecursivePartial<{
    defaultProps?: DynamicDropdownPresentationProps | undefined;
}> = {
    defaultProps: {
        cssOverrides: {
            selectedText: css`
                ${commonTypoStyles}
                padding: 0 8px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;

                &&& {
                    line-height: ${lineHeightSize};
                }

                ${mediaQueriesBP.minMD} {
                    padding: 0 16px;
                }
            `,
            descriptionWrapper: css`
                ${mediaQueriesBP.minMD} {
                    position: absolute;
                }
            `,
        },
    },
};
